export const PAIR_CODE_LENGTH = 5

export const PAIR_ERROR_CODES = {
  EXPIRED: '4020',
  CONNECTION_GONE: '4101',
  MISSING_DATA: '42218',
} as const

// Scoped to the Pair form: 42218 is a generic validation code that other auth
// flows (register phone) must keep rendering with their own fallback.
export const PAIR_ERROR_BODIES = {
  [PAIR_ERROR_CODES.EXPIRED]: 'This code has expired or doesn\'t exist. Generate a new code on your TV and enter it here.',
  [PAIR_ERROR_CODES.CONNECTION_GONE]: 'Your TV closed the pairing screen. Open it again on your TV, keep it open, and enter the new code.',
  [PAIR_ERROR_CODES.MISSING_DATA]: 'We couldn\'t validate the code. Keep the pairing screen open on your TV and try again.',
}
